import { BreadCrumbService } from './../../../../lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { Component, OnChanges, OnInit, ElementRef, ViewEncapsulation, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, AuthenticationService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FilterService } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { MDMDetails } from './../../../models/product';
import { CareComponentService } from '../shared';
import { FanModel } from '../shared';
import { SelectedFan } from '../shared';
import { Router, ActivatedRoute } from '@angular/router';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { CANCELFANDATA } from 'config';
import { PageLoaderService } from '../../../../lib/ng2-sapmp/src/ui-components/page-loader';
import { deviceInventory } from 'config';
import { HttpResponse } from '@angular/common/http';
import { ENV, ADDP_PERMISSION_MAPPING } from 'config';

@Component({
  selector: 'app-select-fan-table',
  templateUrl: './select-fan-table.component.html',
  styleUrls: ['./select-fan-table.component.scss'],
  providers: [FilterService, CareComponentService],
  encapsulation: ViewEncapsulation.None
})

export class SelectFanTableComponent implements OnInit, OnDestroy {
  formName: string;
  companyId: number;
  FANList: Array<FanModel>;
  SelectedFANList: Array<SelectedFan>;
  gridOptions: GridOptionsModel;
  singleFanDetails: any = deviceInventory.singleFanDetail;
  errorMessage: string;
  columnSelection: string;
  callingBackUrl: string;
  selectedFan: string;
  previousRoute: string;
  agentProfileData: any;
  fansRetrieved = false;
  showErrors = false;
  showErrorsPermission = false;
  mdmDetails: MDMDetails;
  goBack: boolean = false;

  constructor(protected careService: CareComponentService, private router: Router, private route: ActivatedRoute,
    private breadCrumbService: BreadCrumbService,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService, private pageloaderService: PageLoaderService, ) {
    this.companyId = 2;  // Company ID four for Revised Setup (All fans)
    this.FANList = [];
    this.SelectedFANList = [];
    this.careService = careService;
    this.columnSelection = 'multicol';
    this.agentProfileData = this.careService.getCareModel();
    this.mdmDetails = new MDMDetails();
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];

    const breadCrumbService = new BreadCrumbModel();
    breadCrumbService.label = 'Retrieving foundation accounts';
    breadCrumbService.routerLink = 'care/selectFanTable';
    this.breadCrumbService.setCurrentBreadCrumb(breadCrumbService);

    this.pageloaderService.setPageLoaderStatus(false);
    // this.breadCrumbService.removeLastBreadCrumb();
    // const callingPageUrl = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    // this.callingBackUrl = callingPageUrl.currentUrl;
    // sessionStorage.setItem('careServiceBackUrl', JSON.stringify({ callingPageUrl }));

    this.SelectedFANList = this.careService.getReviewedFanData();
    // console.log(this.agentProfileData);
    // this.initGrid();
    this.retrieveFans();
    this.pageloaderService.setPageLoaderStatus(true);

  }

  backToCallingPage() {
    this.goBack = true;
    this.agentProfileData.showResetOption = false;
    this.careService.setCareModel(this.agentProfileData);
    this.router.navigate(['care/dashboardTitle']);
  }

  retrieveFans() {
    let url = '';
    if (!this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().careMultiFan;
    }else {
      url = this.utilityService.getEnvConfig().careMultiFanMock;
    }
    this.careService.getMultiFans(url).subscribe(respobj => {
      if (this.goBack !== true && this.router.routerState.snapshot.url === '/care/selectFanTable') {
        if (respobj.errorDescription) {
          this.errorMessage = respobj.errorDescription;
          this.showErrors = true;
          this.pageloaderService.setPageLoaderStatus(true);
        }else {
        this.fansRetrieved = true;
        this.authenticationService.setAuthToken('authToken', respobj.jwtToken);
        sessionStorage.setItem('sapmp_jwtToken', respobj.jwtToken);
        this.continueToNext();
        }
      }
    }, error => {
      this.showErrors = true;
      this.handleError(error);
    });
  }
  initGrid() {

    this.pageloaderService.setPageLoaderStatus(false);
    this.careService.getMultiFans(this.utilityService.getEnvConfig().careMultiFan).subscribe(respobj => {
      if (respobj.errorDescription) {
        this.errorMessage = respobj.errorDescription;
        this.showErrors = true;
        this.pageloaderService.setPageLoaderStatus(true);
      } else {
      this.pageloaderService.setPageLoaderStatus(true);
      const options = new GridOptionsModel();
      options.enableFiltering = true;
      options.enableSorting = true;
      options.multiSelect = false;
      const pagination = {
        recordsPerPage: 20,
        currentPage: 1,
        isServerSide: false,
        totalRecords: respobj.length
      };
      options.enableBackLink = true;
      options.backLinkText = 'View all wireless users for this FAN';
      options.emptyMessage = 'No results';
      options.searchPlaceHolder = 'Search for Wireless Number';

      options.callbacks = {
        callBackAppNameCellTemplate: this.callBackAppNameCellTemplate,
        callBackProfileStatus: this.callBackProfileStatus,
        callBackProfileStatusoem: this.callBackProfileStatusoem
      };
      options.Paginations = pagination;
      options.gridData = respobj;
      options.maxLength = 12;
      options.columnDefinitions = this.singleFanDetails.columnDefinitions;
      options.searchDescriptions = '';
      options.ctnMask = true;
      options.disableGrid = false;
      options.disableRow = false;
      options.disableRowCondition = { field: '', value: '' };
      this.gridOptions = options;
      return this.gridOptions;
      }
    }, error => {
      this.handleError(error);
    });
  }

  /* Fan selection watched here from Grid*/
  onRowClick(action) {
    this.SelectedFANList = action.data;
    this.careService.saveReviewedFan(this.SelectedFANList);
  }

  continueToNext(param?) {
    if (param !== undefined && param === 'continueWithSingle') {
      this.goBack = true;
    }
    this.authenticationService.careUserProfile()
      .subscribe( respobj  => {
        const source = 'care';
        const user = this.authenticationService.getProfileModel(respobj.profile);
        // user.clientIPAddress = this.clientIPAddress;
        // this.authenticationService.setUser(user);
        // sessionStorage.setItem('permissions', JSON.stringify(respobj.permissions));
        if (user.addpAuthority !== 'NONE') {
          this.authenticationService.getFanSignedUpStatus()
            .subscribe(resp => {
                   sessionStorage.setItem("initialSignupStatus", resp.initialSignupStatus);
                   sessionStorage.setItem("noOfDevice", resp.noOfDevices);
                   if (resp.allFansInEligible === true) {
                    user.fanSignedUpStatus = 'NotEligible';
                } else {
              if (user) {
                user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
              }
              if (resp.productCode !== null && resp.productCode !== undefined) {
                this.mdmDetails.productCode = resp.productCode;
                this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
                if (this.mdmDetails.productCode === 'ADDPMDM') {
                  this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
                  let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                  productDetails.emmProductCode = "ADDPMDM";
                  productDetails.selectedAccID = resp.ibmEmmAccountId;
                  productDetails.signupEmmStatus = "revised";
                  sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
                }else {
                    if (resp.googleEmmAccountId !== null && resp.googleEmmAccountId !== undefined) {
                      this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
                    }
                    if (resp.samsungEmmAccountId !== null && resp.samsungEmmAccountId !== undefined) {
                      this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
                    }
                }
                sessionStorage.setItem('mdmDetails', JSON.stringify(this.mdmDetails));
              }
            }
            this.authenticationService.setUser(user);
                sessionStorage.setItem('permissions', JSON.stringify(respobj.permissions));
                const roleFanStaus = user.addpAuthority + '_' + user.fanSignedUpStatus;
                const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
                if (redirectInfo) {
                     this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
                }
                this.router.navigate(['dashboard']);
            }, error => {
              user.fanSignedUpStatus = 'Error';
              this.authenticationService.setUser(user);
              sessionStorage.setItem('permissions', JSON.stringify(respobj.permissions));
              const roleFanStaus = user.addpAuthority + '_' + user.fanSignedUpStatus;
              const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
              if (redirectInfo) {
                    this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
              }
              this.router.navigate(['dashboard']);
            });
        } else {
          this.authenticationService.setUser(user);
          const roleFanStaus = user.addpAuthority + '_' + user.fanSignedUpStatus;
          const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
          if (redirectInfo) {
              this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
          }
          sessionStorage.setItem('permissions', JSON.stringify(respobj.permissions));
            this.router.navigate(['dashboard']);
        }

      }, error => {
        this.errorMessage = 'Something went wrong. Please try again later.';
        this.handleError(error);
      });
  }

  backToCustomerEntryPage() {
    this.goBack = true;
    this.router.navigate(['care/dashboardTitle']);
  }

  handleError(error) {
    throw error;
  }

  callBackProfileStatus(element, row, field, currentElem) {
    const colorStatus = row.status.replace(/_/g, '-').toLowerCase();
    const status = row.status.replace(/_/g, ' ');
    return `<span class='${colorStatus} color-square'></span><span>${status}</span>`;
  }
  
  callBackProfileStatusoem(element, row, field, currentElem) {
    const colorStatus = row.status.replace(/_/g, '-').toLowerCase();
    const status = row.status.replace(/_/g, ' ');
    return `<span class='${colorStatus} color-square'></span><span>${status}</span>`;
  }
  

  /*add two cell for link of CTN and username */
  callBackAppNameCellTemplate(element, row, field, currentElem) {
    if (element.getElementsByTagName('a').length && !element.classList.contains('eventbinded')) {
      const eleA = element.getElementsByTagName('a')[0];
      eleA.onclick = function () {
        currentElem.onDataChange.emit({ data: row, type: 'ctnInfo' });
      };
      element.classList.add('eventbinded');
    }
    const formatctnNumber = row.ctnNumber.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1-$2-$3');
    return `<a href='javascript:void()' class='ctn-number'>${formatctnNumber}</a><p>${row.userName}</p>`;

  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
    const event = document.createEvent('Event');
    event.initEvent('userLogged', true, true);
    document.dispatchEvent(event);
  }

    getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'AWAITING_SIGNUP'; }).length;
      if (signedUpFansCount > 0  && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }


}
